




























































































































































































































import { UserModule } from '@/store/modules/user.module'
import {
  EAdminTaskStatus,
  EAlertStatus,
  EAlertTypePriority,
  EUserStatus,
  IAdminTask,
  IAlert,
  IAlertType,
  IChain,
  IFacility,
  isNonEmptyArray,
  isObj,
  IUser
} from '@zunta/configurations'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { ETableColumnType, ISelectItem, ITableConfig } from '@/interfaces'
import Table from '@/components/tables/Table.vue'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import api from '@/api'
import Avatar from '@/components/Avatar.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import DatepickerLabel from '@/components/labels/DatepickerLabel.vue'
import SelectLabel from '@/components/labels/SelectLabel.vue'
import { ChainModule } from '@/store/modules/chain.module'
import Card from '@/components/Card.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Status from '@/components/statuses/Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ScrollView from '@/components/ScrollView.vue'

const sortBy = require('lodash.sortby')

@Component({
  components: {
    ButtonDownloadReport,
    Status,
    ModalV2,
    Card,
    Table,
    Icon,
    SelectLabel,
    DatepickerLabel,
    DateTimeLabel,
    Avatar,
    LoaderWrapper,
    ScrollView,
  }
})
export default class AdminToDo extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  EAlertTypePriority: any = EAlertTypePriority
  user: any = api.getUser()
  showFacilities: boolean = false
  filters: any = {
    limit: 20,
    skip: 0,
    assignedTo: this.$route.query.assignedTo || this.user.data.id,
    status: ['OVERDUE', 'CURRENT']
  }
  isLoadingReport: boolean = false
  facilityModalLoading = false
  facilitiesDetailsItem: any = null
  windowWidth: number = window.innerWidth

  get config (): ITableConfig {
    const config: ITableConfig = {
      useQuery: true,
      usePagination: true,
      rowClick: this.gotoTodo,
      fetchFunction: this.fetchFunction,
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      columns: [
        {
          class: '',
          minWidth: '100px',
          width: 10,
          key: 'type',
          searchKey: 'type',
          hasSearch: true,
          label: 'Type',
          type: ETableColumnType.select,
          options: [
            {
              key: 'task',
              content: 'Task',
              value: 'task'
            },
            {
              key: 'alert',
              content: 'Alert',
              value: 'alert'
            }
          ]
        },
        {
          class: '',
          minWidth: '150px',
          width: 13,
          key: 'chain',
          searchKey: 'chain',
          hasSearch: true,
          hasSort: true,
          label: 'Chain',
          type: ETableColumnType.default
        },
        {
          class: '',
          minWidth: '150px',
          width: 12,
          key: 'user',
          searchKey: 'user',
          hasSearch: true,
          hasSort: true,
          label: 'Users',
          type: ETableColumnType.default
        },
        {
          class: '',
          minWidth: '150px',
          width: 10,
          key: 'facilityAndChain',
          searchKey: 'facilityAndChain',
          hasSearch: true,
          label: 'Facilities',
          type: ETableColumnType.select,
          options: this.getFacilitiesOptions
        },
        {
          class: '',
          minWidth: '170px',
          width: 15,
          key: 'dueDate',
          searchKey: 'dueDate',
          hasSort: true,
          hasSearch: true,
          label: 'Due Date/Time',
          type: ETableColumnType.dateRange
        },
        {
          class: '',
          minWidth: '150px',
          width: 25,
          key: 'title',
          searchKey: 'title',
          hasSearch: true,
          label: 'Title',
          type: ETableColumnType.default
        },
        {
          class: '',
          minWidth: '170px',
          width: 10,
          key: 'assignedTo',
          hasSort: true,
          searchKey: 'assignedTo',
          hasSearch: true,
          label: 'Assigned To',
          type: ETableColumnType.select,
          options: this.adminUsersItems
        },
        {
          class: '',
          minWidth: '120px',
          width: 10,
          key: 'status',
          searchKey: 'status',
          hasSearch: true,
          label: 'Status',
          type: ETableColumnType.multiselect,
          options: [{
            content: 'Overdue',
            key: 'overdue',
            value: 'OVERDUE'
          }, {
            content: 'Current',
            key: 'current',
            value: 'CURRENT'
          }, {
            content: 'Future',
            key: 'future',
            value: 'FUTURE'
          }, {
            content: 'Complete',
            key: 'complete',
            value: 'COMPLETE'
          }]
        }
      ]
    }
    if (this.isSmallScreen) {
      config.columns = [
        {
          minWidth: '100px',
          width: 10,
          key: 'type',
          searchKey: 'type',
          hasSearch: true,
          label: 'Type',
          type: ETableColumnType.select,
          options: [
            {
              key: 'task',
              content: 'Task',
              value: 'task'
            },
            {
              key: 'alert',
              content: 'Alert',
              value: 'alert'
            }
          ]
        },
        {
          minWidth: '150px',
          width: 18,
          key: 'chain',
          searchKey: 'chain',
          hasSearch: true,
          label: 'Chain',
          hasSort: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 17,
          key: 'user',
          searchKey: 'user',
          hasSort: true,
          hasSearch: true,
          label: 'Users',
          type: ETableColumnType.default
        },
        {
          minWidth: '170px',
          width: 15,
          key: 'dueDate',
          searchKey: 'dueDate',
          hasSort: true,
          hasSearch: true,
          label: 'Due Date/Time',
          type: ETableColumnType.dateRange
        },
        {
          minWidth: '150px',
          width: 25,
          key: 'title',
          searchKey: 'title',
          hasSearch: true,
          label: 'Title',
          type: ETableColumnType.default
        },
        {
          minWidth: '170px',
          width: 10,
          key: 'assignedTo',
          hasSort: true,
          searchKey: 'assignedTo',
          hasSearch: true,
          label: 'Assigned To',
          type: ETableColumnType.select,
          options: this.adminUsersItems
        },
        {
          minWidth: '120px',
          width: 10,
          key: 'status',
          searchKey: 'status',
          hasSearch: true,
          label: 'Status',
          type: ETableColumnType.multiselect,
          options: [{
            content: 'Overdue',
            key: 'overdue',
            value: 'OVERDUE'
          }, {
            content: 'Current',
            key: 'current',
            value: 'CURRENT'
          }, {
            content: 'Future',
            key: 'future',
            value: 'FUTURE'
          }, {
            content: 'Complete',
            key: 'complete',
            value: 'COMPLETE'
          }]
        }
      ]
    }
    return config
  }

  get isSmallScreen (): boolean {
    return this.windowWidth < 1400
  }

  get adminUsers () {
    return this.$store.state.user.adminUsers
  }

  getItemStatus (status: any) {
    if (this.isOverdue(status)) {
      return EStatusType.error
    }
    if (this.isCurrent(status)) {
      return EStatusType.default
    }
    if (this.isComplete(status)) {
      return EStatusType.success
    }
    if (this.isFuture(status)) {
      return EStatusType.pending
    }
    return EStatusType.default
  }

  gotoTodo (item: any) {
    if (item.alert) {
      this.$locationManager.rememberAndGoTo({
        name: 'admin-facilities-users-page-todo',
        params: { id: item.user.id, todo: item.id },
        query: { ...this.$route.query }
      })
      return
    }

    if (item.user) {
      this.$locationManager.rememberAndGoTo({
        name: 'admin-facilities-users-page-todo',
        params: { id: item.user.id, todo: item.id },
        query: { ...this.$route.query, activeTask: item.adminTask.id.toString() }
      })
      return
    }

    this.$locationManager.rememberAndGoTo({
      name: 'admin-chain-page-todo',
      params: { id: item.chain.id, todo: item.id },
      query: { ...this.$route.query, activeTask: item.adminTask.id.toString() }
    })
  }

  get adminUsersItems () {
    const usersOrder = [
      'Esther Singer',
      'Atara Tashman',
      'Ita Klitnick'
    ].map((name: string) => name.toLocaleLowerCase())

    return sortBy(this.adminUsers, (user: IUser) => {
      const index = usersOrder.indexOf(`${user.firstName} ${user.lastName}`.toLocaleLowerCase())
      return index === -1 ? 1000000 : index
    }).map((user: IUser) => {
      return {
        key: user.id,
        value: `${user.id}`,
        content: `${user.firstName} ${user.lastName}`
      }
    })
  }

  get todosTotal () {
    return this.$store.state.user.todosTotal
  }

  get todos () {
    return this.$store.state.user.todos
  }

  get facilities () {
    return this.$store.state.facility.facilities
  }

  get statistics () {
    return this.$store.state.user.todoStatistics
  }

  async mounted () {
    window.addEventListener('resize', this.setWW)
    await this.userModuleInstance.fetchTodoStatistics({
      user: this.filters.assignedTo === 'all' ? undefined : this.filters.assignedTo
    })
    await this.userModuleInstance.getOnlyAdminUsersList({
      status: EUserStatus.ACTIVE
    })
    this.setWW()
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.setWW)
  }

  async changeDueDate (item: any, date: string) {
    const newDueDate = new Date(date)
    const currentDueDate = new Date(item.dueDate)
    newDueDate.setHours(currentDueDate.getHours())
    newDueDate.setMinutes(currentDueDate.getMinutes())
    if (item.adminTask) {
      const func = item.adminTask.trainingMilestone ? this.chainModuleInstance.updateUserAdminTask : this.chainModuleInstance.updateAdminTask
      await func({
        id: item.adminTask.id,
        data: {
          dueDate: newDueDate.getTime()
        },
        template: undefined
      })
    } else {
      await this.userModuleInstance.changeAlertStatus({
        alertId: item.alert.id,
        data: {
          comments: 'Change Due Date',
          dueDate: newDueDate.getTime(),
          status: EAlertStatus.POSTPONED
        }
      })
    }
    // @ts-ignore
    this.$refs.table.initSearch()
  }

  getStatusType (item: IAdminTask | IAlert): EStatusType {
    if (this.isOverdue(item)) {
      return EStatusType.error
    } else if (this.isFuture(item)) {
      return EStatusType.pending
    } else if (this.isComplete(item)) {
      return EStatusType.success
    } else {
      return EStatusType.default
    }
  }

  isOverdue (item: IAdminTask | IAlert) {
    if (!item || this.isComplete(item)) return false
    const today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setSeconds(0)
    today.setMilliseconds(0)
    return new Date(item.dueDate as Date).getTime() < today.getTime()
  }

  isCurrent (item: IAdminTask | IAlert) {
    return !this.isOverdue(item) && !this.isFuture(item) && !this.isComplete(item)
  }

  isFuture (item: IAdminTask | IAlert) {
    if (!item || this.isComplete(item)) return false
    const today = new Date()
    today.setHours(23)
    today.setMinutes(59)
    return new Date(item.dueDate as Date).getTime() >= today.getTime()
  }

  isComplete (item: IAdminTask | IAlert) {
    return [
      EAdminTaskStatus.COMPLETE,
      EAlertStatus.LOOKED_INTO
    ].includes(item.status)
  }

  getStatusLabel (item: IAdminTask | IAlert) {
    if (this.isComplete(item)) {
      return 'Complete'
    } else if (this.isOverdue(item)) {
      return 'Overdue'
    } else if (this.isFuture(item)) {
      return 'Future'
    } else {
      return 'Current'
    }
  }

  async changeAssignedTo (item: any, event: ISelectItem) {
    if (item.adminTask) {
      const func = item.adminTask.trainingMilestone
        ? this.chainModuleInstance.updateUserAdminTask
        : this.chainModuleInstance.updateAdminTask
      await func({
        id: item.adminTask.id,
        data: {
          assignedTo: event.value
        },
        template: undefined
      })
    }
    // @ts-ignore
  }

  getFacilitiesOptions () {
    return this.facilities.map((facility: IFacility) => {
      return {
        key: facility.id,
        value: `${facility.id}-${facility.chain ? (facility.chain as IChain).id : null}`,
        content: facility.name
      }
    })
  }

  getStatisticsTitle (type: string) {
    switch (type) {
      case 'due':
        return 'Due'
      case 'overdue':
        return 'Overdue'
      case 'comingTomorrow':
        return 'Coming Tomorrow'
      case 'week':
        return 'Completed This Week'
      case 'today':
        return 'Completed Today'
      default:
        return 'Unknown'
    }
  }

  toggleCurrentUserItems (value: boolean) {
    this.filters = {
      limit: 20,
      skip: 0,
      assignedTo: value ? 'all' : this.user.data.id,
      status: this.filters.status
    }
  }

  setWW () {
    this.windowWidth = window.innerWidth
  }

  async fetchFunction (query: any) {
    const assignedTo = query.assignedTo === 'all' ? undefined : query.assignedTo
    await this.userModuleInstance.fetchTodos({
      ...query,
      assignedTo
    })
    await this.userModuleInstance.fetchTodoStatistics({
      user: assignedTo
    })
  }

  getAlertToolTipLabel (alert: IAlert) {
    switch ((alert.alertType as IAlertType).priority) {
      case EAlertTypePriority.LOW:
        return 'Not Important'
      case EAlertTypePriority.MEDIUM:
        return 'Medium Priority'
      case EAlertTypePriority.HIGH:
        return 'Very Important'
    }
  }

  getUserFacilities (): any[] {
    return this.facilities.filter((facility: IFacility) => {
      if (this.facilitiesDetailsItem && this.facilitiesDetailsItem.user && facility) {
        return this.facilitiesDetailsItem.user.facilities.includes((facility.id as number).toString())
      }
      return false
    })
  }

  async showFacilitiesDetails (item: any) {
    this.facilitiesDetailsItem = null
    this.showFacilities = true
    this.facilityModalLoading = true
    if (isObj(item.user) && isNonEmptyArray(item.user.facilities)) {
      await this.facilityModuleInstance.getFacilityList({
        facilities: item.user.facilities
      })
      this.facilitiesDetailsItem = item
    }
    this.facilityModalLoading = false
  }
}
